module.exports = __webpack_public_path__ + "static/media/CARATULA SATELITAL.e2e4f8ae.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/CARATULA SATELITAL.pdf
// module id = 773
// module chunks = 0